import React from 'react'

export const CreditCard = ({
  text,
  number,
}: {
  text: string
  number: number
}) => {
  return (
    <div className="bg-baseColorHighlight flex flex-row justify-between rounded-full p-4 w-full">
      <p className="text-base text-neutralColor">{text}</p>
      <p className="text-base text-neutralColor">{number}</p>
    </div>
  )
}
